// Phase D — Welfare payroll API client.
// Wraps /welfare-payroll/* endpoints: ration advance generation + listing.
import apiClient from '@/shared/api/client'

const BASE = '/welfare-payroll'

// ─── Types ───────────────────────────────────────────────────────────────

export interface GenerateAdvancesResult {
  advance_date: string
  period_year: number
  period_month: number
  employees_processed: number
  generated: number
  withheld: number
  skipped_duplicate: number
}

export interface RationAdvanceRow {
  id: string
  employee_id: string
  emp_code: string | null
  emp_name: string | null
  plant_id: string | null
  advance_date: string
  period_year: number
  period_month: number
  amount: number
  attendance_days_in_week: number | null
  attendance_satisfied: boolean
  status: 'PAID' | 'WITHHELD' | 'RECOVERED'
  recovered_in_run_id: string | null
  recovered_at: string | null
  created_at: string | null
  remarks: string | null
}

export interface AdvancesSummaryStatus {
  status: string
  count: number
  total: number
}

export interface AdvancesSummary {
  period: string
  by_status: AdvancesSummaryStatus[]
}

// ─── API ─────────────────────────────────────────────────────────────────

export const welfarePayrollApi = {
  generateAdvances: async (advance_date: string, plant_id?: string): Promise<GenerateAdvancesResult> =>
    (await apiClient.post(`${BASE}/ration-advances/generate`, { advance_date, plant_id: plant_id ?? null })).data,

  listAdvances: async (params: {
    employee_id?: string
    plant_id?: string
    period_year?: number
    period_month?: number
    status?: string
    limit?: number
  } = {}): Promise<RationAdvanceRow[]> =>
    (await apiClient.get(`${BASE}/ration-advances`, { params })).data,

  summary: async (period_year: number, period_month: number, plant_id?: string): Promise<AdvancesSummary> =>
    (await apiClient.get(`${BASE}/ration-advances/summary`, {
      params: { period_year, period_month, plant_id },
    })).data,
}
